import { cva } from "class-variance-authority";

const CAPSULE =
  "inline-flex h-7 items-center justify-center gap-1.5 rounded-pill px-3 text-appkit-caption font-medium text-muted";

export const chipVariants = cva(
  "outline-none transition-colors hover:text-primary focus-visible:ring-2 focus-visible:ring-accent aria-pressed:bg-[var(--color-surface-selected)] aria-pressed:text-primary",
  {
    variants: {
      variant: {
        segmented: CAPSULE,
        chips: CAPSULE,
        /* A word inside running text (Fix a word in Recent dictations). */
        word: "rounded-[6px] px-px text-secondary hover:bg-[var(--color-interactive-hover)] aria-pressed:ring-1 aria-pressed:ring-subtle",
      },
    },
  },
);
